export const convertFileToFormData = (file: any) => {
  const bodyFormData = new FormData();
  bodyFormData.append('file', file);
  return bodyFormData;
};
